import styled, { css } from "styled-components";
import { border, color, onHover, typeStyle, units } from "@m/alchemy-theme";
import { lighten } from "polished";
export const AppMenuList = styled.ul `
  width: 100%;

  ${({ hasIcons }) => hasIcons &&
    css `
      > li a,
      > li button {
        padding-left: ${units(5)};

        svg:first-of-type {
          position: absolute;
          left: ${units(2)};
        }
      }
    `};
`;
export const AppMenuListItem = styled.li `
  position: relative;
  /* ie 11 needs the following line to center items in anchors and buttons */
  display: flex;
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};
  min-height: ${units(3.5)};
  padding: ${units(0.5)} 0;
  width: 100%;
  border-top: ${({ hasDivider }) => (hasDivider ? border() : "none")};
  transition: all 0.2s ease-in;

  button,
  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    width: 100%;
    min-height: ${units(4.5)};
    padding: ${({ hasIcon }) => (hasIcon ? `0 ${units(2)} 0 ${units(6)}` : `0 ${units(2)}`)};
    text-decoration: none;
    color: ${color("typeBody")};
    margin-right: 2px;
    /* Safari needs this to correctly show the outline on ALL elements ¯\_(ツ)_/¯ */
    [data-whatinput="keyboard"] &:focus {
      ${() => css `
        outline: 1px solid
          ${color("contrast", {
    palette: "interactiveConstructive"
})};
      `}
    }
  }

  ::before {
    display: none;
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${units(0.5)};
    min-height: ${units(4.5)};
    height: 85%;
    width: 3px;
    background-color: ${color("base", {
    palette: "interactiveConstructive"
})};
    border-radius: ${units(0.25)};
  }

  ${(props) => onHover(css `
        background-color: ${lighten(0.015, color("hint", { palette: "interactiveConstructive" })(props))};

        ::before {
          display: block;
          background-color: ${color("highlight", {
    palette: "interactiveConstructive"
})};
          padding-left: 4px;
        }
      `, { includeActive: true })}

  [data-whatinput="keyboard"] &:focus-within {
    ${(props) => css `
      background-color: ${lighten(0.015, color("hint", { palette: "interactiveConstructive" })(props))};

      ::before {
        display: block;
        background-color: ${color("highlight", {
    palette: "interactiveConstructive"
})};
      }
    `}
  }

  ${({ isActive }) => isActive &&
    css `
      background-color: ${color("hint", {
        palette: "interactiveConstructive"
    })};
      font-weight: bold;

      ::before {
        display: block;
      }

      /* no hover effects for active items */
      ${() => onHover(css `
            background-color: ${color("hint", {
        palette: "interactiveConstructive"
    })};

            ::before {
              background-color: ${color("base", {
        palette: "interactiveConstructive"
    })};
            }
          `, { includeActive: true })}
    `};

  button {
    color: ${color("typeBody")};
  }

  ul li {
    padding: 0;
  }

  svg {
    margin-right: ${units(1)};
  }
`;
export const IconWrapper = styled.div `
  position: absolute;
  left: ${units(2)};
  top: ${units(1.5)};

  svg {
    color: ${color("base")};
  }
`;
